import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { getLocalizedText } from '../hooks/useLocalizedText';

const COLOR_MAP = {
  ACTIVE: 'green',
  VERIFIED: 'green',
  PAID: 'green',
  COMPLETED: 'green',
  RECEIVED: 'green',
  ACCEPTED: 'green',
  RESOLVED: 'green',
  SIGNED: 'green',
  SUCCESS: 'green',
  TRIALING: 'blue',
  SUSPENDED: 'red',
  REJECTED: 'red',
  OVERDUE: 'red',
  PAST_DUE: 'red',
  FAILED: 'red',
  HIGH: 'red',
  LOW: 'green',
  PENDING: 'gold',
  PENDING_APPROVAL: 'gold',
  WAITING_DOCUMENTS: 'orange',
  DISABLED: 'default',
  INACTIVE: 'default',
  READY: 'gold',
  DRAFT: 'gold',
  UPCOMING: 'gold',
  DUE_SOON: 'gold',
  CLARIFICATION: 'gold',
  IN_PROGRESS: 'gold',
  MEDIUM: 'gold',
  IN_REVIEW: 'blue',
  OPEN: 'blue',
  ISSUED: 'blue',
  CREATED: 'default',
  DEPARTED: 'blue',
  IN_TRANSIT: 'blue',
  ARRIVED: 'cyan',
  DECISION_ISSUED: 'purple',
  PARTIAL: 'orange',
  CANCELLED: 'red',
  CLOSED: 'default',
};

const STATUS_I18N_KEYS = [
  (status) => `deliveries.statuses.${status}`,
  (status) => `deliveries.receiptStatuses.${status}`,
  (status) => `invoices.statuses.${status}`,
  (status) => `payments.statuses.${status}`,
  (status) => `installments.statuses.${status}`,
  (status) => `disputes.statuses.${status}`,
  (status) => `support.statuses.${status}`,
  (status) => `support.priorities.${status}`,
  (status) => `users.statuses.${status}`,
  (status) => `organizations.statuses.${status}`,
  (status) => `organizations.verificationStatuses.${status}`,
  (status) => `subscriptions.statuses.${status}`,
];

function resolveStatusTranslation(status, t) {
  if (!status) return '';
  for (const keyFn of STATUS_I18N_KEYS) {
    const key = keyFn(status);
    const translated = t(key);
    if (translated !== key) return translated;
  }
  return '';
}

/**
 * @param {{ status: string, label?: { en?: string, ar?: string } | string }} props
 */
export default function StatusBadge({ status, label }) {
  const { t, i18n } = useTranslation();
  const color = COLOR_MAP[status] || 'default';
  const locale = i18n.language;

  const fromI18n = resolveStatusTranslation(status, t);
  const fromLabel = label
    ? typeof label === 'string'
      ? label
      : getLocalizedText(label, locale)
    : '';

  const text = fromLabel || fromI18n || status || '';
  return <Tag color={color}>{text}</Tag>;
}
